import styled from "@emotion/styled";
import { GroupAProps } from "@src/ruix/types";

const GroupA = (props: GroupAProps) => {
	const order = props.order;
	const gap = props.gap !== undefined ? props.gap : 4;
	const style = props.style;
	const onClick = props.onClick;

	return (
		<GroupAComponent
			style={{
				width: props.fullWidth ? "100%" : props.width ? props.width : "auto",
				height: props.height ? props.height : "auto",
				backgroundColor: props.bgColor ? props.bgColor : "transparent",
				...(style ? style : {}),
			}}
			className={[order, "group-a"].join(" ")}
			gap={gap}
			onClick={onClick}
		>
			{props.children}
		</GroupAComponent>
	);
};

const GroupAComponent = styled.div<{ gap: number }>`
	gap: ${({ gap }: { gap: number }) => gap}px;
	position: relative;
`;

export default GroupA;
